import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data);
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true, state: { user: res.data } });
      } catch (err) {
        const status = err?.response?.status;
        const detail = err?.response?.data?.detail;
        // V6.3 — Whitelist strict : mapping 403 → écran refus explicite
        let code = "auth_failed";
        if (status === 403) {
          code = detail === "account_disabled" ? "account_disabled" : "not_authorized";
        }
        // eslint-disable-next-line no-console
        console.error("Auth exchange failed", status, detail);
        navigate(`/login?error=${code}`, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--cf-bg)] text-slate-900">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-[color:var(--cf-primary)] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-slate-500 font-semibold">Connexion en cours…</p>
      </div>
    </div>
  );
}
